import ShareIcon from "@mui/icons-material/Share";
import * as React from "react";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";
import {
  RobotoIconButton,
  RobotoTooltip,
  SharedWorkspaceLinkModal,
} from "@/shared/components";
import { enrichVizStateWithEphemeralState } from "@/shared/domain/workspaces/enrichVizStateWithEphemeralState";
import { WorkspaceRecord } from "@/shared/domain/workspaces/WorkspaceRecord";
import { usePopupState } from "@/shared/hooks";
import { ErrorMonitoringService } from "@/shared/services";
import { useVizState } from "@/shared/state/visualization";

import { useEphemeralPanelState } from "../WorkspaceCtx";

export function ShareWorkspaceButton() {
  const state = useVizState();
  const { workspaceService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const [ephemeralPanelState] = useEphemeralPanelState();

  const workspacePopup = usePopupState();
  const [record, setRecord] = React.useState<WorkspaceRecord | null>(null);
  const [createWorkspaceError, setCreateWorkspaceError] =
    React.useState<Error | null>(null);

  const handleShareWorkspace = () => {
    const orgId = currentOrganization?.org_id || "";

    const enrichedVizState = enrichVizStateWithEphemeralState(
      state,
      ephemeralPanelState,
    );

    workspaceService
      .createWorkspace(enrichedVizState, orgId)
      .then((record: WorkspaceRecord) => {
        setRecord(record);
        setCreateWorkspaceError(null);
      })
      .catch((e: Error) => {
        ErrorMonitoringService.captureError(e);
        setCreateWorkspaceError(e);
        setRecord(null);
      })
      .finally(workspacePopup.open);
  };

  return (
    <>
      <RobotoTooltip title="Share workspace">
        <span>
          <RobotoIconButton
            eventName={"ShareWorkspaceClicked"}
            eventProperties={{}}
            onClick={handleShareWorkspace}
            sx={{ padding: "0.5rem" }}
            size="small"
          >
            <ShareIcon
              style={{
                width: "1.25rem",
                height: "1.25rem",
              }}
            />
          </RobotoIconButton>
        </span>
      </RobotoTooltip>

      <SharedWorkspaceLinkModal
        open={workspacePopup.isOpen}
        record={record}
        handleClose={() => {
          setRecord(null);
          workspacePopup.close();
        }}
        error={createWorkspaceError}
      />
    </>
  );
}
